import React from 'react';
import BackendPage from '../../components/page/BackendPage';

export default function DashboardPage() {
	return <BackendPage title="Dr Pam">Coming soon...</BackendPage>;
}
